export const VariantType = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERCIARY: 'terciary',
  GHOST: 'ghost',
  LINK: 'link'
};
export const TypeButton = {
  SUBMIT: 'submit',
  RESET: 'reset',
  BUTTON: 'button'
};
export const IconPosition = {
  LEFT: 'left',
  RIGHT: 'right'
};